module.exports = __webpack_public_path__ + "static/media/team2.5c205b34.png";